<template>
    <rkm-area
        :title="title"
        type="fieldset"
    >
        <template slot="trailing">
            <rkm-button
                @click="internalVisible = !internalVisible"
                color="primary"
                small
            >
                <rkm-icon :icon="internalVisible ? 'angle-double-up' : 'angle-double-down'" />
            </rkm-button>
        </template>

        <rkm-collapse :visible="internalVisible">
            <Historico
                :data="data"
                :readonly="readonly || isAuxiliarTecnicoEnfermagem"
            />

            <OutrasAvaliacoesCondicoes
                :data="data"
            />

            <Diagnostico
                :data="data"
                :readonly="readonly || !isEnfermeiro"
            />

            <Planejamento
                :data="data"
                :readonly="readonly || !isEnfermeiro"
            />

            <Implementacao
                :data="data"
                :readonly="readonly || !isEnfermeiro"
            />

            <Avalicao
                :data="data"
                :readonly="readonly || !isEnfermeiro"
            />

            <Procedimento
                v-if="procedimento"
                :data="data"
                :readonly="readonly || !isEnfermeiro"
            />
        </rkm-collapse>
    </rkm-area>
</template>

<script>
// Components.
import Avalicao from './avalicao/Index'
import Diagnostico from './diagnostico/Index'
import Historico from './historico/Index'
import Implementacao from './implementacao/Index'
import OutrasAvaliacoesCondicoes from '@/components/pronto-atendimento/components/triagem/outras-avaliacoes-condicoes/Index'
import Planejamento from './planejamento/Index'
import Procedimento from './procedimento/Index'

export default {
    components: {
        Avalicao,
        Diagnostico,
        Historico,
        Implementacao,
        OutrasAvaliacoesCondicoes,
        Planejamento,
        Procedimento,
    },
    computed: {
        isEnfermeiro() {

            return this.data.additionals && this.data.additionals.isEnfermeiro
        },
        isAuxiliarTecnicoEnfermagem() {

            return this.data.additionals && this.data.additionals.isAuxiliarTecnicoEnfermagem
        },
    },
    created() {
        this.internalVisible = this.visible
    },
    data: () => ({
        internalVisible: true,
    }),
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
        title: { type: String, default: "Atendimento Enfermagem" },
        visible: { type: Boolean, default: true },
        procedimento: { type: Boolean, default: false },
    },
}
</script>